module.exports = __webpack_public_path__ + "static/media/empty.2b48e4e8.png";